// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, Checkbox, FormControlLabel, TextField } from '@mui/material'
import isEqual from 'lodash/isEqual'
import omit from 'lodash/omit'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import { i18n } from '../../index'
import { fetchOpeningTimes, updateStation } from '../../station/stationQueries'
import type { Station, StationStore } from '../../station/stationTypes'

import Loader from '../../../common/loader/Loader'
import type { User } from '../../auth/types'
import withUser from '../../auth/withUser'
import OpeningTimes from './OpeningTimes'
import css from './stationForm.css'
const defaultFormData = {
  id: '',
  name: '',
  address: '',
  salesIncentiveUnit: 'Pieces',
  buffetGroup: 0,
  buffetBeginAt: '10:30:00',
  buffetEndAt: '13:00:00',
  buffetWeights: [],
  deactivated: false,
}
type StationFormProps = {
  data: Station
  stationStore: StationStore
  user: User
}
type StationFormState = {
  formData: Station
}

@withUser
class StationForm extends React.PureComponent<StationFormProps, StationFormState> {
  state = {
    formData: { ...defaultFormData },
  }

  componentDidMount() {
    const { data } = this.props

    if (data) {
      this.setStateFromData(data)
    }
  }

  componentDidUpdate(prevProps: StationFormProps) {
    const { data } = this.props

    if (data && !isEqual(data, prevProps.data)) {
      this.setStateFromData(data)
    }
  }

  setStateFromData = (data: Station) => {
    this.setState({
      formData: { ...defaultFormData, ...data },
    })
  }
  onInput = (fieldName: string, newValue: string | number) => {
    this.setState({
      formData: { ...this.state.formData, [fieldName]: newValue },
    })
  }
  isValid = () =>
    !isEqual(
      omit(this.props.data, ['buffetWeights', 'profitCenters']),
      omit(this.state.formData, ['buffetWeights', 'profitCenters']),
    )
  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { formData } = this.state
    const station: Station = { ...formData }
    onMutate({
      variables: {
        id: station.id,
        data: omit(station, ['id', 'buffetWeights', 'profitCenters', 'company', 'reminders', '__typename']),
      },
    })
  }

  render() {
    const { formData } = this.state
    const { user } = this.props
    return (
      <Mutation mutation={updateStation}>
        {(onMutate) => (
          <React.Fragment>
            <form noValidate onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.component}>
              <TextField
                required
                label={i18n.t('admin.stations.label.stationName')}
                value={formData.name}
                onChange={(e) => this.onInput('name', e.target.value)}
                className={css.textField}
              />
              <TextField
                required
                label={i18n.t('admin.stations.label.address')}
                value={formData.address}
                onChange={(e) => this.onInput('address', e.target.value)}
                className={css.textField}
              />

              {(user.userType === 'SokAdmin' || user.userType === 'AokAdmin') && (
                <div className={css.checkboxContainer}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.deactivated}
                        onChange={(e) => this.onInput('deactivated', e.target.checked)}
                        className={css.disableCheckbox}
                      />
                    }
                    label={i18n.t('admin.stations.label.disableStation')}
                  />
                </div>
              )}

              <div className={css.actions}>
                <Button type='submit' color='primary' variant='contained' disabled={!this.isValid()}>
                  {i18n.t('buttons.save')}
                </Button>
              </div>
            </form>
            {formData.id && (
              <Query
                query={fetchOpeningTimes}
                variables={{
                  stationId: formData.id,
                }}
              >
                {({ loading, error, data }) => (
                  <Loader
                    {...{
                      loading,
                      error,
                    }}
                  >
                    <OpeningTimes openingTimes={data.openingTimes} />
                  </Loader>
                )}
              </Query>
            )}
          </React.Fragment>
        )}
      </Mutation>
    )
  }
}

export default StationForm
